import type { AppDownloadUtmQuery, SourcebusterData } from '../model/types';

type UtmKey = keyof AppDownloadUtmQuery;

function getSearchParams(url: string): URLSearchParams {
  const hashIndex = url.indexOf('#');
  const urlWithoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const queryIndex = urlWithoutHash.indexOf('?');

  return new URLSearchParams(queryIndex === -1 ? '' : urlWithoutHash.slice(queryIndex));
}

function getPageUtmValue(url: string, key: UtmKey): string | undefined {
  return getSearchParams(url).get(key) || undefined;
}

function getSourcebusterMedium({ src = '', mdm = '' }: SourcebusterData): string | undefined {
  return src || mdm ? `${src}|${mdm}` : undefined;
}

export function getAppDownloadUtmQuery(url: string, sourcebuster: SourcebusterData): AppDownloadUtmQuery {
  return {
    utm_medium: getPageUtmValue(url, 'utm_medium') ?? getSourcebusterMedium(sourcebuster),
    utm_campaign: getPageUtmValue(url, 'utm_campaign') ?? (sourcebuster.cmp || undefined),
    utm_content: getPageUtmValue(url, 'utm_content') ?? (sourcebuster.cnt || undefined),
    utm_term: getPageUtmValue(url, 'utm_term') ?? (sourcebuster.trm || undefined),
  };
}
